import { SVGProps } from 'react';

export const ShowNotesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='22'
    height='22'
    viewBox='0 0 26 25'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M17.223 3.44824H17.8167C19.9523 3.44824 21.6927 4.99716 21.6927 6.90401V19.8262C21.6927 21.733 19.9523 23.2758 17.8167 23.2758H9.04561C6.9031 23.2758 5.16968 21.733 5.16968 19.8262V6.90401C5.16968 4.99716 6.9031 3.44824 9.04561 3.44824H9.45172'
      strokeWidth='1.39852'
      strokeMiterlimit='10'
    />
    <path
      d='M9.98267 10.3447H17.7413'
      strokeWidth='1.45932'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M9.98267 13.793H17.7413'
      strokeWidth='1.45932'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M8.25854 17.2412H17.7413'
      strokeWidth='1.45932'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M16.9812 3.2956C16.9812 4.44283 16.354 5.37291 15.5804 5.37291H11.0853C10.3117 5.37291 9.68457 4.44275 9.68457 3.2956C9.68457 3.2956 9.68457 2.8148 9.68583 2.38464C9.68687 2.01946 9.88668 1.72461 10.1329 1.72461H16.5329C16.7791 1.72461 16.9789 2.01946 16.9799 2.38464C16.9812 2.81472 16.9812 3.2956 16.9812 3.2956Z'
      strokeWidth='1.45932'
      strokeMiterlimit='10'
    />
  </svg>
);
